import type {SuppliedFilterProviderOptions} from '@github-ui/filter-core'
import {DateFilterProvider} from '@github-ui/filter-core/providers'
import {CalendarIcon} from '@primer/octicons-react'

export function getAllDateProviders() {
  return [
    new CreatedFilterProvider({filterTypes: {valueless: false, hasValue: false}}),
    new PushedFilterProvider({filterTypes: {valueless: false, hasValue: false}}),
  ]
}

const NOT_SHOWN = 10

const REPOS_DATE_FILTER_KEYS = {
  created: {
    displayName: 'Created',
    key: 'created',
    priority: NOT_SHOWN,
    icon: CalendarIcon,
    description: 'Creation date',
  },
  pushed: {
    displayName: 'Last updated',
    key: 'pushed',
    priority: NOT_SHOWN,
    icon: CalendarIcon,
    description: 'Last updated date',
  },
}

const TIME_RANGE_VALUES = [
  {displayName: 'Today', value: () => formatDate(new Date()), priority: 1},
  {displayName: 'This month', value: () => `>${formatDate(pastMonthEndDate())}`, priority: 2},
  {displayName: 'This year', value: () => `>${formatDate(pastYearEndDate())}`, priority: 3},
]

function formatDate(date: Date) {
  const [withoutTime] = date.toISOString().split('T')
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return withoutTime!
}

function pastMonthEndDate() {
  const today = new Date()
  return new Date(today.getFullYear(), today.getMonth(), 0)
}

function pastYearEndDate() {
  const today = new Date()
  return new Date(today.getFullYear(), 0, 0)
}

class CreatedFilterProvider extends DateFilterProvider {
  constructor(options?: SuppliedFilterProviderOptions) {
    super(REPOS_DATE_FILTER_KEYS.created, TIME_RANGE_VALUES, options)
  }
}

class PushedFilterProvider extends DateFilterProvider {
  constructor(options?: SuppliedFilterProviderOptions) {
    super(REPOS_DATE_FILTER_KEYS.pushed, TIME_RANGE_VALUES, options)
  }
}
